// In d3-axis, there are hard coded shifts of 0.5. This shift is used for grid alignment and other
// axis alignments.
export const AXIS_SHIFT = 0.5;

// In d3-transition the default transition time is 250ms.
export const TRANSITION_DURATION_MS = 250;
export const TRANSITION_DELAY_MS = 0;
export const TRANSITION_EASE = d3.easeCubic;
export const TRANSITION_EASE_START_POSITION = 0;
export const TRANSITION_EASE_END_POSITION = 1;

export const ENTER = 'enter';
export const UPDATE = 'update';
export const EXIT = 'exit';

export const UPDATE_PATTERN = { ENTER: ENTER, UPDATE: UPDATE, EXIT: EXIT };

export const BRUSH_HANDLE_SIZE = 6;

// In d3-shape, a default size of 64 is used.
export const SYMBOL_SIZE = 64;
